
export function yearsList(yearsLimit) {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < yearsLimit; i++) {
        years.push(currentYear - i);
    }
    return years.reverse()
}

export function monthsList(){
    return [
        { label: 'January', value: 1 },
        { label: 'February', value: 2 },
        { label: 'March', value: 3 },
        { label: 'April', value: 4 },
        { label: 'May', value: 5 },
        { label: 'June', value: 6 },
        { label: 'July', value: 7 },
        { label: 'August', value: 8 },
        { label: 'September', value: 9 },
        { label: 'October', value: 10 },
        { label: 'November', value: 11 },
        { label: 'December', value: 12 }
      ]
}